import { OrganizationInvitationStatus } from 'src/app/admin/models/organization.model';
import { OrganizationRoleTypes } from '../../user/user.enum';
import { OrganizationUser } from '../account-team-user.model';

export function getHighestRoleForOrganization(organizationId: number, user: OrganizationUser) {
  const getRolesForOrganization = () => {
    // if user has been invited to the org but hasn't yet accepted, they do not have the relevant organizationAccesses entry yet, so look in the invitation
    const existingInvitation = user.user_metadata?.invitations?.[organizationId];
    if (existingInvitation?.status === OrganizationInvitationStatus.Sent) {
      return existingInvitation.organizationRoles;
    } else {
      // if current org
      const currentOrgAccess = user.app_metadata?.soulmachines;
      if (organizationId === currentOrgAccess?.organizationId) {
        return currentOrgAccess?.organizationRoles;
      }

      // if in available org accesses
      const allowedOrgAccess = user.app_metadata?.organizationAccesses?.[organizationId];
      if (allowedOrgAccess?.organizationRoles) {
        return allowedOrgAccess.organizationRoles;
      }
    }

    // should not hit this as it means that the user is not active, invited nor does the user belong to this organization
    throw new Error(
      `Unexpected error when getting user ${user.user_id}'s organization role for the organization ${organizationId}`,
    );
  };

  const organizationRoles = getRolesForOrganization();
  return getHighestRole(organizationRoles || []);
}

export function getHighestRole(organizationRoles: string[]) {
  if (organizationRoles.includes(OrganizationRoleTypes.Owner)) {
    return OrganizationRoleTypes.Owner;
  } else if (organizationRoles.includes(OrganizationRoleTypes.Support)) {
    return OrganizationRoleTypes.Support;
  } else if (organizationRoles.includes(OrganizationRoleTypes.Analytics)) {
    return OrganizationRoleTypes.Analytics;
  } else {
    return OrganizationRoleTypes.Editor;
  }
}
